import { injectReducer } from "store/reducers";
import TrashLearningExperiences from "./routes/TrashLearningExperiences";
import TrashLearningCourses from "LearningCoursesBin";
import TrashUnitPlans from "./routes/TrashUnitPlans";
import TrashOrganizationStudents from "./routes/TrashOrgStudents";
import TrashProgressReportSets from "./routes/TrashProgressReportSets";
import TrashClassPlanner from "./routes/TrashClassPlanners";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "trash",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-trash" */ "./components/Trash"),
        import(/* webpackChunkName: "admin-trash" */ "./modules/TrashModule"),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "trash",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    TrashLearningCourses(store),
    TrashUnitPlans(store),
    TrashLearningExperiences(store),
    TrashOrganizationStudents(store),
    TrashProgressReportSets(store),
    TrashClassPlanner(store),
  ],
});
